(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orso-consultation-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orso-banner-carousel')) {
  class OrsoBannerCarousel extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
      this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
      this.controls = this.querySelector('[data-carousel-controls]');
      this.pauseButton = this.querySelector('[data-carousel-pause]');
      this.pauseText = this.querySelector('[data-carousel-pause-text]');
      if (!this.track || !this.slides.length || !this.controls || !this.pauseButton || !this.pauseText) return;
      this.events = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.pendingIndex = null;
      this.navigationSequence = 0;
      this.imageLoads = new WeakMap();
      this.pageLoaded = document.readyState === 'complete';
      this.preloadTask = null;
      this.loadingSlide = false;
      this.pendingAutomatic = false;
      this.userPaused = false;
      this.hovered = this.matches(':hover') && matchMedia('(hover: hover)').matches;
      this.focused = this.contains(document.activeElement);
      this.interacting = false;
      this.timer = null;
      this.pointerStart = null;
      this.suppressClickUntil = 0;
      const options = { signal: this.events.signal };
      this.controls.hidden = this.slides.length < 2;
      this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.goTo(this.navigationIndex() + 1), options);
      this.querySelector('[data-carousel-previous]')?.addEventListener('click', () => this.goTo(this.navigationIndex() - 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));
      this.pauseButton.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.refresh();
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') { this.hovered = true; this.refresh(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.refresh(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.refresh(); }, options);
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (!this.events) return;
        this.focused = this.contains(document.activeElement);
        this.refresh();
      }), options);
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        this.pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.interacting = true;
        this.refresh();
      }, options);
      window.addEventListener('pointerup', event => {
        if (!this.pointerStart || event.pointerId !== this.pointerStart.id) return;
        const dx = event.clientX - this.pointerStart.x;
        const dy = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        this.interacting = false;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.suppressClickUntil = Date.now() + 700;
          this.goTo(this.navigationIndex() + (dx < 0 ? 1 : -1));
        } else this.refresh();
      }, options);
      window.addEventListener('pointercancel', event => {
        if (!this.pointerStart || event.pointerId !== this.pointerStart.id) return;
        this.pointerStart = null;
        this.interacting = false;
        this.refresh();
      }, options);
      this.track.addEventListener('click', event => {
        if (Date.now() < this.suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
      }, { ...options, capture: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); this.goTo(this.navigationIndex() + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.goTo(this.navigationIndex() - 1); }
        if (event.key === 'Home') { event.preventDefault(); this.goTo(0); }
        if (event.key === 'End') { event.preventDefault(); this.goTo(this.slides.length - 1); }
      }, options);
      this.motion.addEventListener('change', () => this.refresh(), options);
      document.addEventListener('visibilitychange', () => {
        this.refresh();
        this.scheduleNextPreload();
      }, options);
      this.track.addEventListener('load', () => this.syncHeight(), { ...options, capture: true });
      this.resize = new ResizeObserver(() => this.syncHeight());
      this.resize.observe(this);
      this.setAttribute('data-carousel-ready', '');
      this.paint();
      this.refresh();
      const afterInitialLoad = () => {
        if (!this.events || this.events.signal.aborted) return;
        this.pageLoaded = true;
        this.scheduleNextPreload();
        this.refresh();
      };
      if (this.pageLoaded) queueMicrotask(afterInitialLoad);
      else window.addEventListener('load', afterInitialLoad, { ...options, once: true });
    }
    rotationAllowed() {
      return this.pageLoaded && this.slides.length > 1 && !this.userPaused && !this.hovered && !this.focused && !this.interacting && !this.motion.matches && !document.hidden;
    }
    canRotate() {
      return !this.loadingSlide && this.rotationAllowed();
    }
    clearTimer() {
      clearTimeout(this.timer);
      this.timer = null;
    }
    refresh() {
      this.clearTimer();
      if (!this.events) return;
      if (this.pendingAutomatic && !this.rotationAllowed()) {
        this.navigationSequence += 1;
        this.pendingIndex = null;
        this.pendingAutomatic = false;
        this.loadingSlide = false;
        this.track.removeAttribute('aria-busy');
      }
      const rotating = this.canRotate();
      this.track.setAttribute('aria-live', rotating ? 'off' : 'polite');
      this.pauseButton.disabled = this.motion.matches;
      this.pauseText.textContent = this.motion.matches ? this.dataset.motionLabel : this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
      if (rotating) this.timer = setTimeout(() => this.goTo(this.navigationIndex() + 1, { automatic: true }), 6000);
    }
    navigationIndex() {
      return this.pendingIndex ?? this.index;
    }
    loadSlide(index) {
      const image = this.slides[index]?.querySelector('img');
      if (!image) return Promise.resolve(false);
      if (this.imageLoads.has(image)) return this.imageLoads.get(image);
      if (image.complete && image.naturalWidth > 0) return Promise.resolve(true);
      const signal = this.events?.signal;
      if (!signal || signal.aborted) return Promise.resolve(false);
      const ready = new Promise((resolve) => {
        let settled = false;
        const finish = (loaded) => {
          if (settled) return;
          settled = true;
          image.removeEventListener('load', loadedImage);
          image.removeEventListener('error', failedImage);
          signal.removeEventListener('abort', failedImage);
          resolve(loaded);
        };
        const loadedImage = async () => {
          if (!image.naturalWidth) { finish(false); return; }
          try { await image.decode?.(); } catch (_) {}
          finish(!signal.aborted && image.naturalWidth > 0);
        };
        const failedImage = () => finish(false);
        image.addEventListener('load', loadedImage);
        image.addEventListener('error', failedImage);
        signal.addEventListener('abort', failedImage, { once: true });
        // A requested hidden slide must load before it becomes visible.
        image.loading = 'eager';
        if (image.dataset.carouselSrcset) {
          image.srcset = image.dataset.carouselSrcset;
          delete image.dataset.carouselSrcset;
        }
        if (image.dataset.carouselSrc) {
          image.src = image.dataset.carouselSrc;
          delete image.dataset.carouselSrc;
        }
        if (image.complete) queueMicrotask(() => {
          if (image.naturalWidth > 0) loadedImage();
          else failedImage();
        });
      });
      this.imageLoads.set(image, ready);
      return ready;
    }
    clearPreload() {
      if (!this.preloadTask) return;
      if (this.preloadTask.kind === 'idle') window.cancelIdleCallback?.(this.preloadTask.id);
      else clearTimeout(this.preloadTask.id);
      this.preloadTask = null;
    }
    scheduleNextPreload() {
      this.clearPreload();
      if (!this.events || !this.pageLoaded || this.slides.length < 2 || document.hidden) return;
      const connection = this.events;
      const next = (this.index + 1) % this.slides.length;
      const preload = () => {
        this.preloadTask = null;
        if (this.events !== connection || connection.signal.aborted || document.hidden) return;
        this.loadSlide(next);
      };
      if (typeof window.requestIdleCallback === 'function') {
        this.preloadTask = { kind: 'idle', id: window.requestIdleCallback(preload, { timeout: 2000 }) };
      } else this.preloadTask = { kind: 'timer', id: setTimeout(preload, 0) };
    }
    async goTo(index, { automatic = false } = {}) {
      if (!this.events || !this.slides.length) return;
      if (automatic && !this.rotationAllowed()) return;
      const target = (index % this.slides.length + this.slides.length) % this.slides.length;
      const connection = this.events;
      const request = ++this.navigationSequence;
      this.pendingIndex = target;
      this.pendingAutomatic = automatic;
      this.loadingSlide = true;
      this.track.setAttribute('aria-busy', 'true');
      this.refresh();
      const loaded = await this.loadSlide(target);
      if (this.events !== connection || connection.signal.aborted || request !== this.navigationSequence) return;
      if (automatic && !this.rotationAllowed()) { this.refresh(); return; }
      this.pendingIndex = null;
      this.pendingAutomatic = false;
      this.loadingSlide = false;
      this.track.removeAttribute('aria-busy');
      if (loaded) {
        this.index = target;
        this.paint();
        this.scheduleNextPreload();
      }
      this.refresh();
    }
    paint() {
      this.slides.forEach((slide, index) => {
        slide.inert = index !== this.index;
        slide.setAttribute('aria-hidden', String(index !== this.index));
      });
      this.dots.forEach((dot, index) => {
        if (index === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.syncHeight();
    }
    syncHeight() {
      const height = this.slides[this.index]?.getBoundingClientRect().height;
      if (height > 0 && Math.abs(parseFloat(this.track.style.height || '0') - height) > 0.5) this.track.style.height = `${height}px`;
    }
    disconnectedCallback() {
      this.navigationSequence += 1;
      this.clearTimer();
      this.clearPreload();
      this.track?.removeAttribute('aria-busy');
      this.events?.abort();
      this.resize?.disconnect();
      this.events = null;
    }
  }
  customElements.define('orso-banner-carousel', OrsoBannerCarousel);
}

  } catch(e) { console.error(e); }
})();
})();
